import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getImports, deleteImport } from "./api";

export default function ImportsList() {
  const [imports, setImports] = useState([]);
  const navigate = useNavigate();

  const fetchImports = async () => {
    const data = await getImports();
    setImports(data);
  };

  useEffect(() => {
    fetchImports();
  }, []);

  const handleEdit = (id) => {
    navigate(`/imports/${id}`);
  };

  const handleDelete = async (id) => {
    await deleteImport(id);

    setImports(prev => prev.filter(i => i.id !== id));
  };

  return (
    <div style={{ padding: 20 }}>
      <h2>Imports</h2>

      <table border="1" cellPadding="10">
        <thead>
          <tr>
            <th>ID</th>
            <th>Name</th>
            <th>Created</th>
            <th>Rows imported</th>
            <th>Rows skipped</th>
            <th>Rows total</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {imports.map((imp) => (
            <tr key={imp.id}>
              <td>{imp.id}</td>
              <td>{imp.name}</td>
              <td>{new Date(imp.created_at).toLocaleString()}</td>
              <td>{imp.rows_imported}</td>
              <td>{imp.rows_skipped}</td>
              <td>{imp.rows_total}</td>
              <td>
                <button onClick={() => handleEdit(imp.id)}>
                  Edit
                </button>

                <button
                  onClick={() => handleDelete(imp.id)}
                  style={{ marginLeft: 10 }}
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
